import React, { useEffect, useState } from "react";
import { getUserCounters } from "../../../../_api/Counter";
import { Loader } from "../../../../_helpers/components/Forms/Loader";
import { Button } from "../../../../_helpers/components/Button";
import { MultiSelect } from "../../../../_helpers/components/Forms/MultiSelect";
import { getCounters, attachCounters } from "../../../../_api/Counter";
import toast from "react-hot-toast";
import { SideBar } from "../../../../_helpers/components/SideBar";
import { dateToAAAAMMJJ, floatRoundToString } from "../../../../_helpers/functions";
import { InputForm } from "../../../../_helpers/components/Forms/InputLabel";
import { addMouvement, hideMouvement, getMouvementsByUserAndCounter } from "../../../../_api/Counter";
import { ListElement } from "../../../../_helpers/components/ListElement";
import { useOutletContext } from "react-router-dom";


const AddMouvementSideBar = (props) => {
    const { closeModal, refresh, counter, employe } = props;
    const [date, setDate] = useState(dateToAAAAMMJJ(new Date(), "-"));
    const [number, setNumber] = useState(0);
    const [comments, setComments] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    const addMouvementModal = () => {
        const payload = {
            date, number, employe_id: employe.id, comments
        }

        setIsSaving(true);
        addMouvement(counter.id, payload).then(resp => {
            refresh();
            closeModal();
            setDate(dateToAAAAMMJJ(new Date(), "-"));
            setNumber(0);
            setComments("");
            toast(resp.data.message);
        }).catch(err => {
            toast(
                err.response.data.message
            );
        }).finally(() => {
            setIsSaving(false);
        });
    }
    const formatDate = (dateInput) => {
        const date = new Date(dateInput);
        const pad = (num) => (num < 10 ? "0" + num : num);
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
            date.getDate()
        )}`;
    };
    return (
        <>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full px-2 mb-3">
                    <InputForm
                        name="Quantité"
                        type="number"
                        required={true}
                        value={number}
                        set={setNumber}
                    />
                </div>
                <div className="w-full px-2 mb-3">
                    <InputForm
                        name="Date d'ajout"
                        type="date"
                        required={true}
                        // min={formatDate(new Date())}
                        // max={formatDate(
                        //     new Date().setFullYear(new Date().getFullYear() + 2)
                        // )}
                        value={date}
                        set={setDate}
                    />
                </div>

            </div>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full px-2 mb-3">
                    <InputForm
                        name="Commentaires"
                        type="textarea"
                        value={comments}
                        set={setComments}
                    />
                </div>
            </div>
            <div className="flex justify-end ml-2 mt-2">

                <div className="m-1">
                    <Button
                        id="add"
                        type={"empty"}
                        action={closeModal}
                        name="Annuler"
                    />
                </div>
                <div className="m-1">
                    <Button id="add" action={() => addMouvementModal()} name="Valider" loading={isSaving} />
                </div>
            </div>
        </>
    );
}
const CompteursTab = (props) => {
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["COUNTERS_USER"]["features"];

    const { profile } = props;

    const [availableCounters, setAvailableCounters] = useState([]);
    const [activeCounters, setActiveCounters] = useState(null);
    const [selectedCounters, setSelectedCounters] = useState([]);

    const [counters, setCounters] = useState([]);
    const [countersTable, setCountersTable] = useState([]);

    const [expandedCounterId, setExpandedCounterId] = useState(null);
    const [mouvementsByCounter, setMouvementsByCounter] = useState({});
    const [loadingMouvementsId, setLoadingMouvementsId] = useState(null);

    const [isLoading, setIsLoading] = useState(true);
    const [isAttaching, setIsAttaching] = useState(false);

    const [openSideBar, setOpenSidebar] = useState(false);
    const [sideBarTitle, setSidebarTitle] = useState("");
    const [sideBarContent, setSidebarContent] = useState("");

    const handleAdd = (e, counter) => {
        e.stopPropagation();
        setSidebarTitle("Ajouter un mouvement");
        setSidebarContent(
            <AddMouvementSideBar
                closeModal={() => setOpenSidebar(false)}
                refresh={refreshPage}
                counter={counter}
                employe={profile}
            />
        );
        setOpenSidebar(true);
    };

    const refreshPage = async (options = {}) => {
        const { clearExpanded = true, showLoader = true } = options;

        if (showLoader) {
            setIsLoading(true);
        }
        if (clearExpanded) {
            setExpandedCounterId(null);
            setMouvementsByCounter({});
        }
        try {
            const resp = await getUserCounters(profile.id);
            setCounters(resp.data);
            setCountersTable(resp.data);
        } catch (err) {
            console.log(err);
            toast.error("Erreur lors du chargement des compteurs.");
        } finally {
            if (showLoader) {
                setIsLoading(false);
            }
        }

        if (clearExpanded) {
            try {
                const resp = await getCounters();
                setAvailableCounters(
                    resp.data.map((data) => {
                        return { value: data.id, label: data.name };
                    })
                );
            } catch (err) {
                console.log(err);
                toast.error("Erreur lors du chargement de la liste des compteurs.");
            }
        }
    }

    useEffect(() => {
        refreshPage();
    }, [profile.id]);

    const hideMouvementModal = async (mouvement, counter) => {
        try {
            const resp = await hideMouvement(mouvement.id);
            toast(resp.data.message);
            await refreshPage({ clearExpanded: false, showLoader: false });
            const page = mouvementsByCounter[counter.id]?.current_page ?? 1;
            const pagination = await getMouvementsByUserAndCounter(profile.id, counter.id, page);
            setMouvementsByCounter((prev) => ({ ...prev, [counter.id]: pagination.data }));
        } catch (err) {
            toast.error(err.response?.data?.message || "Erreur");
        }
    };
    const attachCounter = async () => {
        const currentIDS = countersTable.map((counter) => counter.id);
        setIsAttaching(true);
        try {
            for (const counter of selectedCounters) {
                if (currentIDS.includes(counter.value)) {
                    toast(`Le compteur ${counter.label} est déjà présent.`);
                } else {
                    await attachCounters(profile.id, [counter.value]);
                }
            }
            await refreshPage();
        } finally {
            setIsAttaching(false);
        }
    };

    const loadMouvements = async (counter, page = 1) => {
        if (loadingMouvementsId === counter.id) return;
        setLoadingMouvementsId(counter.id);
        try {
            const resp = await getMouvementsByUserAndCounter(profile.id, counter.id, page);
            setMouvementsByCounter((prev) => ({ ...prev, [counter.id]: resp.data }));
            setExpandedCounterId(counter.id);
        } catch (err) {
            toast.error("Erreur lors du chargement des mouvements.");
        } finally {
            setLoadingMouvementsId(null);
        }
    };

    const getMouvements = async (e, counter) => {
        e.stopPropagation();
        if (expandedCounterId === counter.id) {
            setExpandedCounterId(null);
            setMouvementsByCounter((prev) => {
                const next = { ...prev };
                delete next[counter.id];
                return next;
            });
            return;
        }
        await loadMouvements(counter, 1);
    };

    const formatCounterValue = (rawValue, rawType) => {
        const type = `${rawType ?? ""}`.toUpperCase();
        const value = Number.parseFloat(rawValue);
        if (!Number.isFinite(value)) return "-";

        if (type === "DAYS") {
            return `${floatRoundToString(value, 3)}j`;
        }

        if (type === "HOURS") {
            const sign = value < 0 ? "-" : "";
            const abs = Math.abs(value);
            const totalMinutes = Math.round(abs * 60);
            const h = Math.floor(totalMinutes / 60);
            const m = totalMinutes % 60;
            return m === 0 ? `${sign}${h}h` : `${sign}${h}h${String(m).padStart(2, "0")}`;
        }

        return floatRoundToString(value, 3);
    };

    return (
        <div className="space-y-6">
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    {/* Section Compteurs */}
                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                        <div className="flex items-center justify-between mb-6">
                            <div className="flex items-center">
                                <div className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-lg mr-3">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6 text-blue-600"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                                        />
                                    </svg>
                                </div>
                                <h3 className="text-lg font-semibold text-gray-900">
                                    Compteurs
                                </h3>
                            </div>
                            <div className="flex items-center gap-2">
                                {features_right["link_counter"] && (
                                    <MultiSelect
                                        selections={selectedCounters}
                                        options={availableCounters}
                                        value={""}
                                        isActive={activeCounters}
                                        setActive={(val) => {
                                            setActiveCounters(val);
                                        }}
                                        addSelection={(option) => {
                                            setSelectedCounters([
                                                option,
                                                ...selectedCounters,
                                            ]);
                                            setAvailableCounters(
                                                availableCounters.filter(
                                                    (available) =>
                                                        available.value !== option.value
                                                )
                                            );
                                            setActiveCounters(false);
                                        }}
                                        removeSelection={(option) => {
                                            setAvailableCounters([
                                                option,
                                                ...availableCounters,
                                            ]);
                                            setSelectedCounters(
                                                selectedCounters.filter(
                                                    (available) =>
                                                        available.value !== option.value
                                                )
                                            );
                                            setActiveCounters(false);
                                        }}
                                    />
                                )}
                                <Button
                                    id="add"
                                    type="empty"
                                    isVisible={features_right["link_counter"]}
                                    action={() => attachCounter()}
                                    loading={isAttaching}
                                    name={
                                        <span className="flex items-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5 mr-1"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M12 4v16m8-8H4"
                                                />
                                            </svg>
                                            Ajouter un compteur
                                        </span>
                                    }
                                />
                            </div>
                        </div>

                        <div className="space-y-3">
                            {counters && counters.length > 0 ? (
                                counters.map((counter) => {
                                    return (
                                        <div key={counter.id}>
                                            <ListElement
                                                onClick={(e) => {
                                                    // Ouvrir les détails du compteur si nécessaire
                                                    getMouvements(e, counter);
                                                }}
                                                text={counter.name}
                                                description={`${formatCounterValue(counter.total_mvt - counter.futur_mvt, counter.type)} / ${formatCounterValue(counter.futur_mvt, counter.type)}`}
                                                info={`Solde: ${formatCounterValue(counter.total_mvt, counter.type)}`}
                                                action={
                                                    <button
                                                        type="button"
                                                        onClick={(e) => handleAdd(e, counter)}
                                                        aria-label="Ajouter un mouvement"
                                                        title="Ajouter un mouvement"
                                                        className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-gray-200 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 transition-colors"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16M4 12h16" />
                                                        </svg>
                                                    </button>
                                                }
                                            />
                                            {/* Sous-table des mouvements */}
                                            {expandedCounterId === counter.id && (
                                                <div className="ml-4 mt-2 space-y-2">
                                                    {loadingMouvementsId === counter.id ? (
                                                        <div className="flex items-center justify-center py-6 text-gray-500 text-sm">Chargement…</div>
                                                    ) : mouvementsByCounter[counter.id]?.data?.length > 0 ? (
                                                        <>
                                                            <div className="overflow-x-auto rounded-lg border border-gray-200 bg-gray-50">
                                                                <table className="min-w-full divide-y divide-gray-200 text-sm">
                                                                    <thead className="bg-gray-100">
                                                                        <tr>
                                                                            <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600">Date création</th>
                                                                            <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600">Date planning</th>
                                                                            <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600">Créateur</th>
                                                                            <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600">Source</th>
                                                                            <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600">Valeur</th>
                                                                            <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600"></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="divide-y divide-gray-200 bg-white">
                                                                        {mouvementsByCounter[counter.id].data.map((mouvement) => {
                                                                            const isInactive = mouvement.is_actived === false;
                                                                            return (
                                                                                <tr
                                                                                    key={mouvement.id}
                                                                                    className={isInactive ? "bg-red-50 text-red-700" : ""}
                                                                                >
                                                                                    <td className="px-3 py-2 text-xs">
                                                                                        {new Date(mouvement.created_at).toLocaleString()}
                                                                                    </td>
                                                                                    <td className="px-3 py-2 text-xs">
                                                                                        {new Date(mouvement.planning_date).toLocaleDateString()}
                                                                                    </td>
                                                                                    <td className="px-3 py-2 text-xs">
                                                                                        {mouvement.action_user ? (mouvement.action_user?.last_name + " " + mouvement.action_user?.first_name) : "Hordyplan"}
                                                                                    </td>
                                                                                    <td className="px-3 py-2 text-xs">
                                                                                        {mouvement.type}
                                                                                    </td>
                                                                                    <td className="px-3 py-2 text-xs font-medium">
                                                                                        {mouvement.mouvement}
                                                                                    </td>
                                                                                    <td className="px-3 py-2">
                                                                                        {mouvement.type === "MANUAL" && (
                                                                                            <button
                                                                                                onClick={() => hideMouvementModal(mouvement, counter)}
                                                                                                className="text-red-600 hover:text-red-800 transition-colors"
                                                                                                title="Supprimer"
                                                                                            >
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                                                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                                                </svg>
                                                                                            </button>
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            {mouvementsByCounter[counter.id].last_page > 1 && (
                                                                <div className="flex items-center justify-between px-2 py-2 text-sm text-gray-600">
                                                                    <span>
                                                                        Page {mouvementsByCounter[counter.id].current_page} / {mouvementsByCounter[counter.id].last_page}
                                                                        {" "}({mouvementsByCounter[counter.id].total} mouvement{mouvementsByCounter[counter.id].total > 1 ? "s" : ""})
                                                                    </span>
                                                                    <div className="flex gap-2">
                                                                        <button
                                                                            type="button"
                                                                            onClick={(e) => { e.stopPropagation(); loadMouvements(counter, mouvementsByCounter[counter.id].current_page - 1); }}
                                                                            disabled={mouvementsByCounter[counter.id].current_page <= 1}
                                                                            className="px-3 py-1 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                                                        >
                                                                            Précédent
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            onClick={(e) => { e.stopPropagation(); loadMouvements(counter, mouvementsByCounter[counter.id].current_page + 1); }}
                                                                            disabled={mouvementsByCounter[counter.id].current_page >= mouvementsByCounter[counter.id].last_page}
                                                                            className="px-3 py-1 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                                                        >
                                                                            Suivant
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <div className="py-4 text-center text-sm text-gray-500">Aucun mouvement</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="text-center py-8 text-gray-500">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-12 w-12 mx-auto mb-3 text-gray-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                                        />
                                    </svg>
                                    <p className="text-sm">Aucun compteur</p>
                                    {features_right["link_counter"] && (
                                        <p className="text-xs text-gray-400 mt-1">
                                            Cliquez sur "Ajouter un compteur" pour en créer un
                                        </p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}

            <SideBar
                title={sideBarTitle}
                content={sideBarContent}
                isOpen={openSideBar}
                onClose={() => {
                    setOpenSidebar(false);
                }}
            />
        </div>
    );
};

export default CompteursTab;
